<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      @closed="closed"
      append-to-body
      width="460px"
    >
      <div class="dialogContent">
        <div class="title">申请发票</div>
        <el-form :model="form" ref="form" @submit.native.prevent label-position="top">
          <el-form-item
            prop="type"
            label="发票类型"
            :rules="{ required: true, message: '请选择发票类型' }"
          >
            <el-select
              class="el-style-select"
              v-model="form.type"
              placeholder="请选择发票类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in InvoiceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="titleType"
            label="抬头类型"
            :rules="{ required: true, message: '请选择抬头类型' }"
          >
            <el-select
              class="el-style-select"
              v-model="form.titleType"
              placeholder="请选择抬头类型"
              style="width: 100%"
              :disabled="titleTypeDisabled"
            >
              <el-option
                v-for="item in InvoiceTitleTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="发票抬头"
            prop="title"
            :rules="{ required: true, message: '请输入发票抬头' }"
          >
            <el-input
              placeholder="请输入发票抬头"
              style="width: 100%"
              v-model="form.title"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单位税号"
            prop="taxId"
            :rules="{ required: true, message: '请输入单位税号' }"
            v-if="taxShow"
          >
            <el-input
              placeholder="请输入单位税号"
              style="width: 100%"
              v-model="form.taxId"
            ></el-input>
          </el-form-item>
          <template v-if="form.type === 2">
            <el-form-item
              label="开户银行"
              prop="bankName"
              :rules="{ required: true, message: '请输入开户银行' }"
            >
              <el-input
                placeholder="请输入开户银行"
                style="width: 100%"
                v-model="form.bankName"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="银行账号"
              prop="bankAccountNumber"
              :rules="{ required: true, message: '请输入银行账号' }"
            >
              <el-input
                placeholder="请输入银行账号"
                style="width: 100%"
                v-model="form.bankAccountNumber"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="单位地址"
              prop="companyAddress"
              :rules="{ required: true, message: '请输入单位地址' }"
            >
              <el-input
                placeholder="请输入单位地址"
                style="width: 100%"
                v-model="form.companyAddress"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="单位电话"
              prop="companyPhoneNumber"
              :rules="{ required: true, message: '请输入单位电话' }"
            >
              <el-input
                placeholder="请输入单位电话"
                style="width: 100%"
                v-model="form.companyPhoneNumber"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
        <div class="btns">
          <el-button size="mini" class="btn" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" class="btn" @click="onSubmit" size="mini"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectData from "@/mixins/selectData";
export default {
  mixins: [selectData],
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        type: null,
        titleType: null,
        title: null,
        taxId: null,
        bankName: null,
        bankAccountNumber: null,
        companyAddress: null,
        companyPhoneNumber: null,
        tradeNoList: [],
      },
    };
  },
  watch: {
    "form.type"(val) {
      if (val === 2) {
        this.form.titleType = 1;
      } else {
        this.clear();
      }
    },
    "form.titleType"(val) {
      this.clear();
    },
  },
  computed: {
    titleTypeDisabled() {
      const { type } = this.form;
      if (type === 2) {
        return true;
      }
      return false;
    },
    taxShow() {
      const { type, titleType } = this.form;
      if (type === 2) {
        return true;
      }
      if (titleType === 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clear() {
      this.form = {
        ...this.form,
        taxId: null,
        bankName: null,
        bankAccountNumber: null,
        companyAddress: null,
        companyPhoneNumber: null,
      };
    },
    onShow(tradeNoList) {
      this.form.tradeNoList = tradeNoList;
      this.dialogVisible = true;
    },
    async onSubmit() {
      try {
        const passThrough = await this.$refs.form.validate();
        passThrough && this.putInvoice();
        
      }catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialogVisible = false;
    },
    closed() {
      this.$refs.form.resetFields();
    },
    async putInvoice() {
      const { form } = this;
      const { status, info } = await this.$api.putInvoice(
        this.$utils.filterFalsyValues({ ...form })
      );
      if (status === 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.close();
        this.$emit("success");
        return status;
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogContent {
  background: #ffffff;
  @include dialogDefStyle;
  @include formStyle;
  .btns {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
    .btn {
      @include buttonStyle2;
    }
  }
}
</style>
